import * as React from 'react';
/**
 *
 * Original name: archive
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1015
 *
 */
export const ArchiveLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m14.543 11.5-.075.666C14.328 13.4 13.603 14 12.25 14s-2.078-.6-2.218-1.834l-.075-.666H4.5v7H20v-7h-5.457ZM18.5 17H6v-4h2.668c.434 1.579 1.731 2.5 3.582 2.5 1.851 0 3.15-.921 3.582-2.5H18.5v4Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "m14.07 7.71 1.04 1.08-2.86 2.75-2.86-2.75 1.04-1.08 1.07 1.029V5H13v3.739l1.07-1.03Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
